import * as React from 'react'
import { useState } from 'react'

import { Box, Icon, tokens } from '@factorialco/deprecated-design-system'
import { A11y, Keyboard, Navigation, type Swiper as SwiperType, Thumbs } from 'swiper'
import 'swiper/css/bundle'
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react'

import i18n from 'modules/core/lib/i18n'

import * as styles from './index.vanilla.css'

type mediaProps = {
  media: {
    alt: string | null | undefined
    placeholder?: string
    url: string | null | undefined
  }[]
}

const checkIsVideo = (itemUrl: string) => {
  return itemUrl.includes('.mp4') || itemUrl.includes('.webm')
}

const Carousel = ({ media }: mediaProps) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperType | null>(null)
  const mainSwiperRef = React.useRef<SwiperRef>(null)

  return (
    <>
      {media.length > 0 && (
        <Box paddingTop="s32" width="full">
          <div className={styles.carousel}>
            <Swiper
              thumbs={{ swiper: thumbsSwiper }}
              modules={[Navigation, Thumbs, A11y]}
              className={styles.mainImage}
              ref={mainSwiperRef}
            >
              {media.map((item, key) => (
                <SwiperSlide key={key}>
                  {checkIsVideo(item.url!) && (
                    <video
                      controls
                      src={item.url!}
                      poster={item.placeholder}
                      title={item.alt!}
                    ></video>
                  )}

                  {!checkIsVideo(item.url!) && <img src={item.url!} alt={item.alt!} />}
                </SwiperSlide>
              ))}
            </Swiper>
            <div className={styles.thumbsWrapper}>
              <Swiper
                onSwiper={setThumbsSwiper}
                spaceBetween={parseInt(tokens.dimensions.s24)}
                slidesPerView={4}
                watchSlidesProgress
                navigation={{ nextEl: '#next', prevEl: '#prev' }}
                modules={[Keyboard, Navigation, Thumbs, A11y]}
                className={styles.thumbs}
                keyboard={{ enabled: true }}
                a11y={{
                  slideRole: 'button',
                  prevSlideMessage: i18n.t('marketplace.carousel.carousel_prev'),
                  nextSlideMessage: i18n.t('marketplace.carousel.carousel_next'),
                }}
              >
                {media.length > 1 &&
                  media.map((item, key) => (
                    <SwiperSlide
                      key={key}
                      className={styles.thumb}
                      tag={'button'}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          if (mainSwiperRef?.current) {
                            mainSwiperRef.current.swiper.slideTo(key)
                          }
                        }
                      }}
                    >
                      <img src={item.placeholder ? item.placeholder : item.url!} />
                    </SwiperSlide>
                  ))}
              </Swiper>
              <button id="prev" className={`${styles.navigationButtons} ${styles.navigationPrev}`}>
                <Icon.Medium icon="chevron-left" color="grey800" />
              </button>
              <button id="next" className={`${styles.navigationButtons} ${styles.navigationNext}`}>
                <Icon.Medium icon="chevron-right" color="grey800" />
              </button>
            </div>
          </div>
        </Box>
      )}
    </>
  )
}

export default Carousel
